import TechnicalEquipmentTypeIcon from "@mui/icons-material/ElectricalServices";
import ListTechnicalEquipmentTypes from "./List";
import { TECHNICAL_EQUIPMENT, AdministrationServicePath } from "utils/constants";
import CreateTechnicalEquipmentTypes from "./Create";
import EditTechnicalEquipmentTypes from "./Edit";
import ShowTechnicalEquipmentTypes from "./Show";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";

//permissions
export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <TechnicalEquipmentTypeIcon />,
  name: AdministrationServicePath + TECHNICAL_EQUIPMENT,
  title: "Техническо оборудване",
  list: <ListTechnicalEquipmentTypes />,
  create: <CreateTechnicalEquipmentTypes />,
  createPermission: permissions.canCreateTechnicalEquipment,
  edit: <EditTechnicalEquipmentTypes />,
  editPermission: permissions.canUpdateTechnicalEquipment,
  show: <ShowTechnicalEquipmentTypes />,
  showPermission: permissions.canPreviewTechnicalEquipment,
  permission: permissions.canPreviewTechnicalEquipment,
};
